import React from 'react';
import type { WallStance } from '../../core/types/payloads/wall.types';

const SAMPLE_NOTES = [
  'Los datos apoyan esta postura…',
  'Desde mi experiencia en clase…',
  'Un contraargumento clave…',
];

function noteTilt(index: number): number {
  const tilts = [0.45, -0.5, 0.35, -0.4, 0.5, -0.35];
  return tilts[index % tilts.length] ?? 0.4;
}

function MockPostIt({ text, color, index }: { text: string; color: string; index: number }) {
  return (
    <article
      className="wall-editor-post-it shadow-sm"
      style={{
        ['--stance-color' as string]: color,
        transform: `rotate(${noteTilt(index)}deg)`,
      }}
    >
      <p>{text}</p>
    </article>
  );
}

export interface WallDebatePreviewProps {
  stances: WallStance[];
  prompt?: string;
  editable?: boolean;
  onPromptChange?: (v: string) => void;
  onStanceLabelChange?: (stanceId: string, label: string) => void;
}

export function WallDebatePreview({
  stances,
  prompt,
  editable = false,
  onPromptChange,
  onStanceLabelChange,
}: WallDebatePreviewProps) {
  return (
    <div className="wall-editor-stage">
      {(prompt != null || editable) && (
        <div className="wall-editor-prompt-wrap">
          {editable && onPromptChange ? (
            <textarea
              className="wall-editor-prompt canvas-inline-input canvas-inline-input--title"
              rows={2}
              value={prompt ?? ''}
              placeholder="¿Cuál es tu postura?"
              onChange={(e) => onPromptChange(e.target.value)}
            />
          ) : (
            prompt && <p className="wall-editor-prompt wall-editor-prompt--static">{prompt}</p>
          )}
        </div>
      )}

      <div className={`wall-editor-columns ${stances.length >= 3 ? 'wall-editor-columns--3' : ''}`}>
        {stances.map((stance, colIdx) => (
          <section
            key={stance.id}
            className="wall-editor-column"
            style={{ ['--stance-color' as string]: stance.color }}
          >
            <header className="wall-editor-column__head">
              {editable && onStanceLabelChange ? (
                <input
                  className="wall-editor-column__label-input canvas-inline-input"
                  value={stance.label}
                  placeholder="Postura"
                  onChange={(e) => onStanceLabelChange(stance.id, e.target.value)}
                />
              ) : (
                <span className="wall-editor-column__badge">{stance.label}</span>
              )}
            </header>
            <div className="wall-editor-column__body">
              {colIdx === 0 && (
                <MockPostIt text={SAMPLE_NOTES[0]!} color={stance.color} index={0} />
              )}
              {colIdx === 1 && stances.length >= 2 && (
                <>
                  <MockPostIt text={SAMPLE_NOTES[1]!} color={stance.color} index={1} />
                  <MockPostIt text={SAMPLE_NOTES[2]!} color={stance.color} index={2} />
                </>
              )}
              {colIdx >= 2 && (
                <div className="wall-editor-column__empty">
                  <span>Argumentos en vivo</span>
                </div>
              )}
              {stances.length === 1 && (
                <div className="wall-editor-column__empty">
                  <span>Argumentos en vivo</span>
                </div>
              )}
            </div>
          </section>
        ))}
      </div>
    </div>
  );
}
